import {
  ACTIVITIES_SEARCHED_REVIEWS,
  ActivitiesDetailsProperties,
  ExperiencesShopReviewsResponse,
  ITrackingProperties,
} from "redmond";
import { put, select } from "redux-saga/effects";
import { actions } from "../actions";
import Logger from "../../../utils/logger";
import { fetchExperiencesShopReviews } from "../../../api/v0/shop/fetchExperiencesShopReviews";
import { trackEvent } from "../../../api/v0/analytics/trackEvent";
import { getActivityDetailsProperties } from "../reducer";

export function* fetchExperiencesShopReviewsSaga(
  action: actions.IFetchExperiencesShopReviews
) {
  try {
    const reviewsResponse: ExperiencesShopReviewsResponse =
      yield fetchExperiencesShopReviews(action.request);
    yield put(actions.setExperiencesShopReviews(reviewsResponse));

    // Only fire once a search term has been typed instead of on page load with ""
    if (action.request.refinement.query) {
      const activityDetailsProperties: ITrackingProperties<ActivitiesDetailsProperties> =
        yield select(getActivityDetailsProperties);
      const { properties, encryptedProperties } = activityDetailsProperties;

      trackEvent({
        eventName: ACTIVITIES_SEARCHED_REVIEWS,
        properties: {
          search_term: action.request.refinement.query,
          ...properties,
        },
        encryptedProperties: [...(encryptedProperties ?? "")],
      });
    }
  } catch (e) {
    yield put(actions.setExperiencesShopReviewsCallStateFailed());
    Logger.debug(e);
  }
}
